const sizes = {
  formDrawer: '500px',
};

export default sizes;
